// 默认值配置页

// path的默认值
export const defaultPath={
    // 由于后端返回的路径都不一致  这里对路径做传参兼容处理
    //读取列表时的path
    listPath:'result.result',
    // pageInfo所在路径
    pagePath:'result.pageInfo',
    // 获取保存监测点点接口读取列表时读取的路径
    savePath:'result',
}